/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type PleaseCallMeMutationInput = {
    email: string;
    accountNumber: string;
    name: string;
    companyName: string;
    subjectLine: string;
    contactNumber: string;
    depositIssueFile?: unknown | null;
    clientMutationId?: string | null;
};
export type PleaseCallMeMutationVariables = {
    input: PleaseCallMeMutationInput;
};
export type PleaseCallMeMutationResponse = {
    readonly pleaseCallMe: {
        readonly clientMutationId: string | null;
        readonly accepted: ReadonlyArray<string> | null;
        readonly rejected: ReadonlyArray<string> | null;
    } | null;
};
export type PleaseCallMeMutation = {
    readonly response: PleaseCallMeMutationResponse;
    readonly variables: PleaseCallMeMutationVariables;
};



/*
mutation PleaseCallMeMutation(
  $input: PleaseCallMeMutationInput!
) {
  pleaseCallMe(input: $input) {
    clientMutationId
    accepted
    rejected
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "PleaseCallMeMutationPayload",
    "kind": "LinkedField",
    "name": "pleaseCallMe",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "accepted",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "rejected",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PleaseCallMeMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PleaseCallMeMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ba867919728bff25a6b6adc4f2b58ab1",
    "id": null,
    "metadata": {},
    "name": "PleaseCallMeMutation",
    "operationKind": "mutation",
    "text": "mutation PleaseCallMeMutation(\n  $input: PleaseCallMeMutationInput!\n) {\n  pleaseCallMe(input: $input) {\n    clientMutationId\n    accepted\n    rejected\n  }\n}\n"
  }
};
})();
(node as any).hash = 'c03ef4caecaf79782909ed01197e8516';
export default node;
